import logoUrl from '@/assets/AzimutLogoShort.svg';

type AzimutLogoShortProps = {
  alt?: string;
  className?: string;
  width?: number;
  height?: number;
  priority?: boolean;
};

export const AzimutLogoShort = ({
  alt = 'Azimut logo',
  className,
  width,
  height,
  priority = true,
}: AzimutLogoShortProps) => (
  <img
    src={logoUrl}
    alt={alt}
    width={width}
    height={height}
    className={className}
    loading={priority ? 'eager' : 'lazy'}
    decoding="async"
    fetchPriority={priority ? 'high' : 'auto'}
    draggable={false}
  />
);
